export const data = [
    {
        "id":2,
        "title":"200+ Technical Resources in 5 years",
         url1: require('./images/Services.png'),
         "subtitle": "Since 2019 we placed nearly 200+ Technical resources in various spectrums such as UI/UX Developers, Project Managers, Architects GoLang/JAVA Developers and AI/ML Ops Engineers etc."
    },
    {
        "id":4,
        "title":"Up to 4 Weeks",
        url1: require('./images/icon-people.png'),
        "subtitle":"Start reviewing profiles in a week and close requisition in 4 weeks. On average, we close requisition with less than 4 interviews in 4 weeks."
    },
    {
        "id":1,
        "title":"20+ Projects in 5 years",
         url1: require('./images/Services.png'),
         "subtitle":"Our goal is simple! Deliver  high quality service while keeping the cost significantly  less than our competition. Delivered various projects of various technologies such as application modernization,  cloud & containers and  improved  observability with open source."

    },    
    {
        "id":3,
        "title":"Haulr LLC, Mobile Solution for the Construction and Trucking Industry.",
        url1: require('./images/globe.png'),
        "subtitle":" <b>Haulr</b> is a comprehensive  market place solution for hiring and dispatching trucks to construction projects. By replacing paper tickets with e-tickets, Haulr ensures accurate tracking of critical data, such as ClockIn, ClockOut times, and the details of each trip made. This not only eliminates paperwork but also provides essential information to resolve invoicing discrepancies and enables faster, more accurate payments "

    },
]